import { render, staticRenderFns } from "./shareModal.vue?vue&type=template&id=2c83799a&"
import script from "./shareModal.vue?vue&type=script&lang=js&"
export * from "./shareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports